import Typography from '@/ui/components/typography'
import {
    DescriptionWrapper,
    LinkButtonWrapper,
    TermsOfServiceBannerWrapper,
    FooterSection,
} from '../FraudDefenseMarketing.styles'
import { InfoBanner } from '@/ui/components/BannerAlert'
import { useCustomTheme, TTheme } from '@/core/theme'
import { Analytics } from '@/core/services/mixpanel/mixpanel.service'

const FooterSectionComponent = () => {
    const theme = useCustomTheme() as TTheme

    const handleContactExpertClick = () => {
        Analytics.event('SEM::user_clicked_chat')
        window.Intercom('show')
    }

    return (
        <FooterSection>
            <TermsOfServiceBannerWrapper>
                <InfoBanner
                    data-testid="fraud-defense-marketing-admin-access-banner"
                    title={
                        <Typography
                            variant="s-semibold"
                            color={theme.colors.greys[900]}
                        >
                            Only account admins can set up new integrations due
                            to access restrictions.
                        </Typography>
                    }
                    description={
                        <DescriptionWrapper>
                            <Typography variant="s-regular">
                                By signing up, you acknowledge and agree to the
                                following{' '}
                            </Typography>
                            <LinkButtonWrapper
                                to="https://www.at-bay.com/stance/terms-of-service/"
                                text="terms of service"
                                external={true}
                                withChevron={false}
                                variant="s-regular"
                                className="fraud-defense-terms-of-service"
                            />
                        </DescriptionWrapper>
                    }
                />
            </TermsOfServiceBannerWrapper>
            <Typography variant="xs-regular">
                Need help or additional data?{' '}
                <span
                    className="contact-link"
                    onClick={handleContactExpertClick}
                >
                    Contact an Expert
                </span>
            </Typography>
        </FooterSection>
    )
}

export default FooterSectionComponent
